import { useLanguage } from "../i18n/LanguageContext";
import { legal } from "../i18n/legal";
import ContentPage from "../components/ContentPage";

export function PrivacyPolicy() {
  const { lang } = useLanguage();
  return <ContentPage content={legal.privacy[lang]} />;
}

export function CookiePolicy() {
  const { lang } = useLanguage();
  return <ContentPage content={legal.cookies[lang]} />;
}
